import React from "react";
import "./WalletComponent.css";
import { GoCopy } from "react-icons/go";
import { Apiurl } from "../../Pages/utils/page";
import PointsAnalyticModal from "./PointsAnalyticModal";
import AddPointModal from "./AddPointModal";
import { toast } from "react-toastify";
const WalletComponent = ({
  ReferralData,
  handleCopyUrl,
  showAlert,
  handleShow,
  handleClose,
  show,
  analyticData,
  pointSummaryData,
  setPointSummaryData,

  filterData,
  setFilteredData,
  setAddPointModal,
  addPointModal,
  handleCloseAddPointModal,
  pointSLabData,
  handleSelectPoint,
  selectedSlab,
  setSelectedSlab,
  handlePay,
  getProfileData,
  profileImage
}) => {
  return (
    <>
      <div className="container" style={{ flex: "1" }}>
        <div className="row">
          <div className="col-lg-12 col-12">
            <div className="wallet-section">
              <div className="WalletComponent-main-section">
                <div
                  className="row"
                  b-0a6nyo83bz=""
                  style={{ alignItems: "center" }}
                >
                  <div className="col-lg-1 col-4 col-sm-auto d-flex justify-content-center" b-0a6nyo83bz="">
                    {" "}
                    <img
                      src={profileImage}
                      className="wallet_image"
                      alt=""
                      layout="intrinsic"
                      onError={(e) => {
                        e.target.onerror = null; // Prevent infinite loop
                        e.target.src = "/Images/unisexImage.jpeg";
                      }}
                    />
                  </div>
                  <div className="col-lg-11 col-6">
                    <div className="text-sm-left mb-sm-0" b-0a6nyo83bz="">
                      <h4
                        className="pt-sm-2 pb-1 mb-0 text-nowrap"
                        b-0a6nyo83bz=""
                      >
                        Hello, {ReferralData?.Name}
                      </h4>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  {/* <div className="col-lg-4 col-sm-4 col-12">
                    <div className="wallet_input">
                      <div className="form-group">
                        <label for="BalanceMoney">Wallet Money</label>
                        <div className="main_money_wallet_wraper">
                          <input
                            id="BalanceMoney"
                            className="form-control BalanceMoney-input"
                            type="text"
                            name="BalanceMoney"
                            placeholder="Balance Money"
                            disabled
                          />
                          <input
                            type="button"
                            value="Wallet History"
                            className="WalletHistory-button"
                          />
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div className="col-lg-4 col-sm-4 col-12">
                    <div className="wallet_input">
                      <div className="form-group">
                        <label for="BalancePoint">Your Points</label>
                        <div className="main_money_wallet_wraper">
                          <input
                            id="BalancePoint"
                            className="form-control BalanceMoney-input"
                            type="text"
                            name="BalancePoint"
                            value={ReferralData?.BalancePoint}
                            placeholder="Balance Point"
                            disabled
                          />
                          <input
                            type="button"
                            value="Points History"
                            className="WalletHistory-button"
                            onClick={() => handleShow()}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-4 col-12">
                    <div className="form-group wallet_input">
                      <label for="ReferralCode">Referral Code</label>
                      <input
                        value={ReferralData.ReferralCode}
                        id="ReferralCode"
                        className="form-control"
                        type="text"
                        name="ReferralCode"
                        placeholder="Referral Code"
                        disabled
                      />
                      <div className="Copy-Referral-code">
                        <label>Copy Referral Code:</label>
                        <a title="Copy referral code">
                          <GoCopy onClick={handleCopyUrl} />
                        </a>
                      </div>
                      {!showAlert && (
                        <div
                          className="alert alert-success alert-dismissible copy-code"
                          role="alert"
                        >
                          Copied!
                        </div>
                      )}
                    </div>
                  </div>
                  {getProfileData?.IsInBusiness ? (
                    <div className="col-lg-12">
                      <button
                        type="button"
                        className="AddMoney-In-Wallet-button"
                        onClick={() => {
                          if (pointSLabData?.length) {
                            setAddPointModal(true);
                          } else {
                            toast.error(
                              "Currently no Plans Available For Add Points"
                            );
                          }
                        }}
                      >
                        Add Points
                      </button>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PointsAnalyticModal
        show={show}
        handleClose={handleClose}
        analyticData={analyticData}
        pointSummaryData={pointSummaryData}
        setPointSummaryData={setPointSummaryData}
        setFilteredData={setFilteredData}
        filterData={filterData}
        getProfileData={getProfileData}
      />
      <AddPointModal
        addPointModal={addPointModal}
        handleCloseAddPointModal={handleCloseAddPointModal}
        pointSLabData={pointSLabData}
        handleSelectPoint={handleSelectPoint}
        selectedSlab={selectedSlab}
        setSelectedSlab={setSelectedSlab}
        setAddPointModal={setAddPointModal}
        handlePay={handlePay}
      />
    </>
  );
};
export default WalletComponent;
